<section class="nw_service_th" *ngIf="businessListData.length > 0">
  <div class="service_se">
    <div class="flexs_rtr">
      <div class="heading_sert">
        <h3>All bookings / activity</h3>
      </div>

      <!-- insert here -->
      <!-- <div
        class=""
        style="width: 15%"
        *ngIf="selectedBusiness.revenue_model == 1"
      >
        <button
          *ngIf="isAccessForEmployeeInvoice"
          mat-icon-button
          class="Create_header_btn"
          color="primary"
          aria-label="Add new booking"
          style="padding-top: 0"
          (click)="createNewBookingFromList()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div> -->
      <div
        class=""
        style="width: 15%"
      >
        <!-- Add button -->
        <button
          *ngIf="isAccessForEmployeeInvoice"
          mat-icon-button
          class="Create_header_btn"
          color="primary"
          aria-label="Add new booking"
          [matMenuTriggerFor]="menu"
          style="padding-top: 0px"
        >
          <mat-icon>add</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="createNewBookingFromList()">
            <mat-icon class="material-icons-outlined">event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterestFromList()">
            <mat-icon class="material-icons-outlined"
              >card_membership</mat-icon
            >
            <span>New membership request</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="chip_services_list">
      <mat-chip-listbox>
        <mat-chip
          (click)="selectBusiness(i)"
          *ngFor="let item of businessListData; let i = index"
          [ngClass]="{ 'Graceful-box-active': item.isSelected == 1 }"
          >{{ item.name }}</mat-chip
        >
      </mat-chip-listbox>
    </div>
  </div>

  <div class="service_create_sd">
    <div class="row">
      <div class="col-sm-12">
        <div class="">
          <div class="serv_heading">
            <h3>
              {{
                selectedBusiness.revenue_model == 1
                  ? (selectedValueForBeauty == "1"
                    ? "Bookings"
                    : selectedValueForBeauty == "2"
                    ? "Membership requests"
                    : "Queries")
                  : selectedBusiness.revenue_model == 2
                  ? selectedValue == "1"
                    ? "Membership requests"
                    : selectedValue == "2"
                    ? "Session bookings"
                    : selectedValue == '4' ? 'Queries' : "Attendances"
                  : ""
              }}
              of {{ selectedBusiness.name }}
            </h3>
            <p>{{ selectedBusiness.address_line }}</p>
          </div>
        </div>
      </div>

      <!-- insert here -->

      <div class="col-sm-12">
        <div class="date-range-form">
          <div class="nw_all">
            <mat-form-field
              appearance="outline"
              (click)="fromDatePicker.open()"
            >
              <mat-label>From Date</mat-label>
              <input
                matInput
                [matDatepicker]="fromDatePicker"
                [(ngModel)]="fromDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fromDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #fromDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="nw_all">
            <mat-form-field appearance="outline" (click)="toDatePicker.open()">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [matDatepicker]="toDatePicker"
                [(ngModel)]="toDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="search_pag">
            <button
              (click)="search()"
              mat-flat-button
              color="primary"
              type="submit"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedBusiness.revenue_model == 2" style="margin-bottom: 20px">
    <div class="chip_services_list">
      <mat-chip-listbox>
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '3' }"
          (click)="changeChip('3')"
          >Attendance</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '2' }"
          (click)="changeChip('2')"
          >Session Booking</mat-chip
        >
         <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '1' }"
          (click)="changeChip('1')"
          >Membership request
        </mat-chip>
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '4' }"
          (click)="changeChip('4')"
          >Customer queries
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>
  <div *ngIf="selectedBusiness.revenue_model == 1" style="margin-bottom: 20px">
    <div class="chip_services_list">
      <mat-chip-listbox>
       <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValueForBeauty == '1' }"
          (click)="changeChipForBeauty('1')"
          >Bookings</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValueForBeauty == '2' }"
          (click)="changeChipForBeauty('2')"
          >Membership request</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValueForBeauty == '3' }"
          (click)="changeChipForBeauty('3')"
          >Customer queries
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>

  <!-- Beauty bookings code start-->
  <div
    class="showll_cards"
    *ngIf="
      selectedBusiness.revenue_model == 1 && bookingsList.length > 0 && !loader
    "
  >
    <div class="row">
      <div
        class="col-sm-4"
        *ngFor="let item of bookingsList"
        (click)="bookingDetails(item)"
      >
        <mat-card>
          <div class="booking-card">
            <div class="booking-header">
              <div class="left-section" style="position: relative">
                <div
                  *ngIf="
                    !item.customerInfo.imgThumbUrl ||
                    item.customerInfo.imgThumbUrl == 'null'
                  "
                  [class.new-booking]="
                    item.bookingStatus == 0 ||
                    item.bookingStatus == 1 ||
                    item.bookingStatus == 2
                  "
                  [class.under-process]="
                    item.bookingStatus == 3 ||
                    item.bookingStatus == 7 ||
                    item.bookingStatus == 9
                  "
                  [class.completed]="item.bookingStatus == 4"
                  [class.cancelled]="
                    item.bookingStatus == 6 || item.bookingStatus == 8
                  "
                  [class.confirmed]="item.bookingStatus == 5"
                  class="status-icon"
                ></div>
                <div
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null'
                  "
                  [class.new-booking]="
                    item.bookingStatus == 0 ||
                    item.bookingStatus == 1 ||
                    item.bookingStatus == 2
                  "
                  [class.under-process]="
                    item.bookingStatus == 3 ||
                    item.bookingStatus == 7 ||
                    item.bookingStatus == 9
                  "
                  [class.completed]="item.bookingStatus == 4"
                  [class.cancelled]="
                    item.bookingStatus == 6 || item.bookingStatus == 8
                  "
                  [class.confirmed]="item.bookingStatus == 5"
                  class="status-icon"
                ></div>
                <div
                  class="booking-initial"
                  *ngIf="
                    !item.customerInfo.imgThumbUrl ||
                    item.customerInfo.imgThumbUrl == 'null'
                  "
                >
                  {{ item.customerName.slice(0, 1) }}
                </div>
                <img
                  class="booking-initial-img img-fluid rounded-circle"
                  [src]="item.customerInfo.imgThumbUrl"
                  alt=""
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null'
                  "
                  onerror="this.src='../../../../assets/images/user-avatar.svg'"
                />
                <div class="booking-details">
                  <h3 class="booking-name">{{ item.customerName }}</h3>
                  <p class="booking-number">
                    <span class="bookingstar"
                      >{{ item.bookingStartTime }} -
                      {{ item.bookingEndTime }},</span
                    >
                    #{{ item.appointment_no }}
                  </p>
                </div>
              </div>
              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
        <mat-icon>more_vert</mat-icon>
      </button> -->
              <mat-menu #menu="matMenu">
                <!-- <button mat-menu-item (click)="confirmBooking(item)" *ngIf="(((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2) && (item.customerInfo.hash_id && item.customerInfo.hash_id != 'null')) && (item.toshowOptions == 1))">
            <mat-icon class="material-icons-outlined">check_circle</mat-icon>
            <span>Confirm booking</span>
        </button> -->
                <button mat-menu-item (click)="bookingDetails(item)">
                  <mat-icon class="material-icons-outlined">info</mat-icon>
                  <span>Booking details</span>
                </button>
                <!-- <button mat-menu-item *ngIf="item.bookingStatus == 4" (click)="openInvoice(item)">
            <mat-icon class="material-icons-outlined">badge</mat-icon>
            <span>Invoice</span>
        </button>
        <button mat-menu-item (click)="cancelBooking(item)" *ngIf="(((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 5)) && (item.toshowOptions == 1 && selectedBusiness.is_owner == 1))">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Cancel booking</span>
        </button>
        <button mat-menu-item *ngIf="(!item.customerInfo.hash_id || item.customerInfo.hash_id == 'null') && selectedBusiness.is_owner == 1" (click)="deleteBooking(item)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>Delete booking</span>
        </button> -->
              </mat-menu>
            </div>

            <p class="booking-meta">
              <span class="label">Assigned to: </span>
              <span class="value">{{ item.employeeName }}</span>
            </p>
            <p class="booking-meta">
              <span class="label">Service mode: </span>
              <span class="value">{{ item.booking_type }}</span>
            </p>
            <p class="booking-meta">
              <span class="label">Status: </span>
              <span class="value">{{ item.bookingStat }}</span>
              <span
                class="label"
                *ngIf="item.paymentStat && item.paymentStat != '---'"
                >, Payment:
              </span>
              <span
                class="value"
                *ngIf="item.paymentStat && item.paymentStat != '---'"
                >{{ item.paymentStat }}</span
              >
            </p>

            <p class="date_booking">{{ item.bookingDate | date }}</p>
          </div>
          <div class="arrow_iocn_x">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </mat-card>
        <!-- </mat-card> -->
      </div>
    </div>
  </div>

  <!-- Beauty bookings code end-->

  <!-- QUERIES START -->
  <div
    class="showll_cards"
    *ngIf="
      (selectedBusiness.revenue_model == 2 &&
      selectedValue == '1' &&
      interestData.length > 0 &&
      !loader) || (selectedBusiness.revenue_model == 1 &&
      selectedValueForBeauty == '2' &&
      interestData.length > 0 &&
      !loader)
    "
  >
    <div class="row">
      <div
        class="col-sm-4"
        *ngFor="let item of interestData"
        (click)="viewDetails(item)"
      >
        <mat-card>
          <div class="booking-card">
            <div class="booking-header">
              <!-- <div class="left-section">
            <div class="booking-initial">{{item.customer_name.slice(0,1)}}</div>
            <div class="booking-details">
              <h3 class="booking-name">{{item.customer_name}}</h3>
            </div>
          </div> -->
              <div class="left-section" style="position: relative">
                <div
                  [class.new-booking]="item.enrollment_request_status == 1"
                  [class.under-process]="item.enrollment_request_status == 2"
                  [class.completed]="item.enrollment_request_status == 5"
                  [class.cancelled]="item.enrollment_request_status == 4"
                  [class.confirmed]="item.enrollment_request_status == 3"
                  class="status-icon"
                ></div>

                <div class="booking-initial">
                  {{ item.customer_name.slice(0, 1) }}
                </div>

                <div class="booking-details">
                  <h3 class="booking-name">{{ item.customer_name }}</h3>
                     <p class="booking-meta">
                     <span class="value">{{ item.phone }}</span>
                    </p>
                </div>
              </div>
              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
            <mat-icon>more_vert</mat-icon>
          </button> -->
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="viewDetails(item)">
                  <mat-icon class="material-icons-outlined">info</mat-icon>
                  <span>View details</span>
                </button>
                <!-- <button mat-menu-item (click)="changeRequestStatus(item,1)" *ngIf="item.enrollment_request_status != 1 &&  item.enrollment_request_status != 5 && selectedBusiness.is_owner == 1">
               <mat-icon class="material-icons-outlined">grade</mat-icon>
               <span>Mark as new</span>
               </button>
              <button mat-menu-item (click)="changeRequestStatus(item,2)" *ngIf="item.enrollment_request_status != 2 &&  item.enrollment_request_status != 5 && selectedBusiness.is_owner == 1">
               <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
               <span>Mark as in-progress</span>
               </button>
               <button mat-menu-item (click)="changeRequestStatus(item,3)" *ngIf="item.enrollment_request_status != 3 &&  item.enrollment_request_status != 5  && selectedBusiness.is_owner == 1">
               <mat-icon class="material-icons-outlined">task_alt</mat-icon>
               <span>Mark as enrolled</span>
               </button>
               <button mat-menu-item (click)="changeRequestStatus(item,4)" *ngIf="item.enrollment_request_status != 4 &&  item.enrollment_request_status != 5 && selectedBusiness.is_owner == 1">
               <mat-icon class="material-icons-outlined">cancel</mat-icon>
               <span>Mark as cancelled</span>
               </button> -->

                <button
                  mat-menu-item
                  (click)="deleteQuery(item)"
                  *ngIf="
                    (!item.customer_account_hash ||
                      item.customer_account_hash == 'null') &&
                    selectedBusiness.is_owner == 1
                  "
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span> Delete query</span>
                </button>
              </mat-menu>
            </div>

            <p class="booking-meta">
              <span class="label">Status: </span>
              <span class="value">{{ item.item_status }}</span>
            </p>
             <p class="booking-meta">
              <span class="label">Service mode: </span>
              <span class="value">{{ item.service_mode }}</span>
            </p>
            <p class="booking-meta">
              <span class="label">Services: </span>
              <span class="value">{{ item.opted_services }} </span>
              <!-- <span class="value">{{item.bookingStartTime}} - {{item.bookingEndTime}}</span>  -->
            </p>
            <p class="booking-meta">
              <span class="value">{{ item.creation_time | date }}</span>
            </p>
          </div>
          <div class="arrow_iocn_x">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <!-- QUERIES END -->

  <!-- fitness session booking code start -->

  <div
    class="showll_cards"
    *ngIf="
      !loader &&
      messageList.length > 0 &&
      selectedBusiness.revenue_model == 2 &&
      selectedValue == '2'
    "
  >
    <div class="row">
      <div
        class="col-sm-4"
        *ngFor="let item of messageList"
        (click)="bookingDetailsForHistory(item)"
      >
        <mat-card>
          <div class="booking-card">
            <div class="booking-header">
              <!-- <div class="left-section">
            <div class="booking-initial">{{item.customerName.slice(0,1)}}</div>
            <div class="booking-details">
              <h3 class="booking-name">{{item.customerName}}</h3>
              <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2>
            </div>
          </div> -->
              <div class="left-section" style="position: relative">
                <div
                  *ngIf="
                    (!item.customerInfo.imgThumbUrl ||
                      item.customerInfo.imgThumbUrl == 'null') &&
                    item.data_type == 1
                  "
                  [class.new-booking]="
                    (item.bookingStatus == 0 ||
                      item.bookingStatus == 1 ||
                      item.bookingStatus == 2) &&
                    item.data_type == 1
                  "
                  [class.under-process]="
                    (item.bookingStatus == 3 ||
                      item.bookingStatus == 7 ||
                      item.bookingStatus == 9) &&
                    item.data_type == 1
                  "
                  [class.completed]="
                    item.bookingStatus == 4 && item.data_type == 1
                  "
                  [class.cancelled]="
                    (item.bookingStatus == 6 || item.bookingStatus == 8) &&
                    item.data_type == 1
                  "
                  [class.confirmed]="
                    item.bookingStatus == 5 && item.data_type == 1
                  "
                  class="status-icon"
                ></div>
                <div
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null' &&
                    item.data_type == 1
                  "
                  [class.new-booking]="
                    (item.bookingStatus == 0 ||
                      item.bookingStatus == 1 ||
                      item.bookingStatus == 2) &&
                    item.data_type == 1
                  "
                  [class.under-process]="
                    (item.bookingStatus == 3 ||
                      item.bookingStatus == 7 ||
                      item.bookingStatus == 9) &&
                    item.data_type == 1
                  "
                  [class.completed]="
                    item.bookingStatus == 4 && item.data_type == 1
                  "
                  [class.cancelled]="
                    (item.bookingStatus == 6 || item.bookingStatus == 8) &&
                    item.data_type == 1
                  "
                  [class.confirmed]="
                    item.bookingStatus == 5 && item.data_type == 1
                  "
                  class="status-icon"
                ></div>

                <div
                  *ngIf="
                    (!item.customerInfo.imgThumbUrl ||
                      item.customerInfo.imgThumbUrl == 'null') &&
                    item.data_type == 2
                  "
                  [class.cancelled]="
                    item.bookingStatus == 0 && item.data_type == 2
                  "
                  [class.new-booking]="
                    item.bookingStatus == 1 &&
                    !item.session_status &&
                    item.data_type == 2
                  "
                  [class.under-process]="
                    item.bookingStatus == 1 &&
                    (item.session_status == 2 || item.session_status == 1) &&
                    item.data_type == 2
                  "
                  [class.completed]="
                    item.bookingStatus == 1 &&
                    item.session_status == 3 &&
                    item.data_type == 2
                  "
                  class="status-icon"
                ></div>
                <div
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null' &&
                    item.data_type == 2
                  "
                  [class.cancelled]="
                    item.bookingStatus == 0 && item.data_type == 2
                  "
                  [class.new-booking]="
                    item.bookingStatus == 1 &&
                    !item.session_status &&
                    item.data_type == 2
                  "
                  [class.under-process]="
                    item.bookingStatus == 1 &&
                    (item.session_status == 2 || item.session_status == 1) &&
                    item.data_type == 2
                  "
                  [class.completed]="
                    item.bookingStatus == 1 &&
                    item.session_status == 3 &&
                    item.data_type == 2
                  "
                  class="status-icon"
                ></div>
                <div
                  class="booking-initial"
                  *ngIf="
                    !item.customerInfo.imgThumbUrl ||
                    item.customerInfo.imgThumbUrl == 'null'
                  "
                >
                  {{ item.customerName.slice(0, 1) }}
                </div>
                <img
                  class="booking-initial-img img-fluid rounded-circle"
                  [src]="item.customerInfo.imgThumbUrl"
                  alt=""
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null'
                  "
                  onerror="this.src='../../../../assets/images/user-avatar.svg'"
                />
                <!-- <div class="booking-details">
              <h3 class="booking-name">{{item.customerName}}</h3>
              <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2>
            </div> -->

                <div class="booking-details">
                  <h3 class="booking-name">{{ item.customerName }}</h3>
                  <p class="booking-number">
                    <span class="bookingstar"
                      >{{ item.bookingStartTime }} - {{ item.bookingEndTime }},
                    </span>
                    <span *ngIf="item.data_type == 1 && item.appointment_no"
                      >#{{ item.appointment_no }}
                    </span>
                  </p>
                </div>
              </div>
              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
            <mat-icon>more_vert</mat-icon>
          </button> -->
              <mat-menu #menu="matMenu">
                <div *ngIf="item.data_type == 1">
                  <!-- <button mat-menu-item (click)="confirmBookingForHistory(item)" *ngIf="(((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2) && (item.customerInfo.hash_id && item.customerInfo.hash_id != 'null')) && (item.toshowOptions == 1))">
                  <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                  <span>Confirm booking</span>
              </button> -->
                  <button
                    mat-menu-item
                    (click)="bookingDetailsForHistory(item)"
                  >
                    <mat-icon class="material-icons-outlined">info</mat-icon>
                    <span>Booking details</span>
                  </button>
                  <!-- <button mat-menu-item *ngIf="item.bookingStatus == 4" (click)="openInvoiceForHistory(item)">
                  <mat-icon class="material-icons-outlined">badge</mat-icon>
                  <span>Invoice</span>
              </button>
              <button mat-menu-item (click)="cancelBookingForHistory(item)" *ngIf="(((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 5)) && (item.toshowOptions == 1 && selectedBusiness.is_owner == 1))">
                <mat-icon class="material-icons-outlined">cancel</mat-icon>
                <span>Cancel booking</span>
              </button>
              <button mat-menu-item *ngIf="(!item.customerInfo.hash_id || item.customerInfo.hash_id == 'null') && selectedBusiness.is_owner == 1" (click)="deleteBookingForHistory(item)">
                <mat-icon class="material-icons-outlined">delete</mat-icon>
                <span>Delete booking</span>
              </button> -->
                </div>

                <div *ngIf="item.data_type == 2">
                  <button
                    mat-menu-item
                    (click)="changeAttendanceStatus(1, item)"
                    *ngIf="
                      item.bookingStatus == 0 ||
                      item.bookingStatus == null ||
                      item.bookingStatus == 'null'
                    "
                    [disabled]="selectedBusiness.is_owner == 0"
                  >
                    <mat-icon class="material-icons-outlined"
                      >check_circle</mat-icon
                    >
                    <span>mark as present</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="changeAttendanceStatus(0, item)"
                    *ngIf="
                      item.bookingStatus == 1 ||
                      item.bookingStatus == null ||
                      item.bookingStatus == 'null'
                    "
                    [disabled]="selectedBusiness.is_owner == 0"
                  >
                    <mat-icon class="material-icons-outlined">cancel</mat-icon>
                    <span>mark as absent</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1"
                    (click)="deleteAttendance(item)"
                    [disabled]="selectedBusiness.is_owner == 0"
                  >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete attendance</span>
                  </button>
                </div>
              </mat-menu>
            </div>

            <p class="booking-meta">
              <span class="label">Assigned to: </span>
              <span class="value">{{ item.employeeName }}</span>
            </p>
             <p class="booking-meta">
              <span class="label">Service mode: </span>
              <span class="value">{{ item.booking_type }}</span>
            </p>
            <p class="booking-meta">
              <span class="label">Status: </span>
              <span class="value">{{ item.bookingStat }}</span>
              <span
                class="label"
                *ngIf="item.paymentStat && item.paymentStat != '---'"
                >, Payment:
              </span>
              <span
                class="value"
                *ngIf="item.paymentStat && item.paymentStat != '---'"
                >{{ item.paymentStat }}</span
              >
            </p>
            <p class="date_booking" *ngIf="item.booking_date">
              {{ item.booking_date ? (item.booking_date | date) : "---" }}
            </p>
          </div>
          <div class="arrow_iocn_x">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- fitness session booking code end -->

  <!-- fitness attendance code -->

  <div
    class="showll_cards"
    *ngIf="
      !loader &&
      attendanceList.length > 0 &&
      selectedBusiness.revenue_model == 2 &&
      selectedValue == '3'
    "
  >
    <div class="row">
      <div class="col-sm-4" *ngFor="let item of attendanceList">
        <mat-card>
          <div class="booking-card">
            <div class="booking-header">
              <!-- <div class="left-section">
            <div class="booking-initial">{{item.customerName.slice(0,1)}}</div>
            <div class="booking-details">
              <h3 class="booking-name">{{item.customerName}}</h3>
              <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2>
            </div>
          </div> -->
              <div class="left-section" style="position: relative">
                <div
                  *ngIf="
                    (!item.customerInfo.imgThumbUrl ||
                      item.customerInfo.imgThumbUrl == 'null') &&
                    item.data_type == 2
                  "
                  [class.cancelled]="
                    item.bookingStatus == 0 && item.data_type == 2
                  "
                  [class.new-booking]="
                    item.bookingStatus == 1 &&
                    !item.session_status &&
                    item.data_type == 2
                  "
                  [class.under-process]="
                    item.bookingStatus == 1 &&
                    (item.session_status == 2 || item.session_status == 1) &&
                    item.data_type == 2
                  "
                  [class.completed]="
                    item.bookingStatus == 1 &&
                    item.session_status == 3 &&
                    item.data_type == 2
                  "
                  class="status-icon"
                ></div>
                <div
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null' &&
                    item.data_type == 2
                  "
                  [class.cancelled]="
                    item.bookingStatus == 0 && item.data_type == 2
                  "
                  [class.new-booking]="
                    item.bookingStatus == 1 &&
                    !item.session_status &&
                    item.data_type == 2
                  "
                  [class.under-process]="
                    item.bookingStatus == 1 &&
                    (item.session_status == 2 || item.session_status == 1) &&
                    item.data_type == 2
                  "
                  [class.completed]="
                    item.bookingStatus == 1 &&
                    item.session_status == 3 &&
                    item.data_type == 2
                  "
                  class="status-icon"
                ></div>
                <div
                  class="booking-initial"
                  *ngIf="
                    !item.customerInfo.imgThumbUrl ||
                    item.customerInfo.imgThumbUrl == 'null'
                  "
                >
                  {{ item.customerName.slice(0, 1) }}
                </div>
                <img
                  class="booking-initial-img img-fluid rounded-circle"
                  [src]="item.customerInfo.imgThumbUrl"
                  alt=""
                  *ngIf="
                    item.customerInfo.imgThumbUrl &&
                    item.customerInfo.imgThumbUrl != 'null'
                  "
                  onerror="this.src='../../../../assets/images/user-avatar.svg'"
                />
                <!-- <div class="booking-details">
              <h3 class="booking-name">{{item.customerName}}</h3>
              <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2>
            </div> -->

                <div class="booking-details">
                  <h3 class="booking-name">{{ item.customerName }}</h3>
                  <p class="booking-number">
                    <span class="bookingstar"
                      >{{ item.bookingStartTime }} -
                      {{ item.bookingEndTime }}</span
                    >
                  </p>
                </div>
              </div>
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                class="custom-icon-button"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <div *ngIf="item.data_type == 2">
                  <button
                    mat-menu-item
                    (click)="changeAttendanceStatus(1, item)"
                    *ngIf="
                      (item.bookingStatus == 0 ||
                        item.bookingStatus == null ||
                        item.bookingStatus == 'null') &&
                      selectedBusiness.is_owner == 1 && item.session_status != 3
                    "
                  >
                    <mat-icon class="material-icons-outlined"
                      >check_circle</mat-icon
                    >
                    <span>mark as present</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="changeAttendanceStatus(0, item)"
                    *ngIf="
                      (item.bookingStatus == 1 ||
                        item.bookingStatus == null ||
                        item.bookingStatus == 'null') &&
                      selectedBusiness.is_owner == 1 && item.session_status != 3
                    "
                  >
                    <mat-icon class="material-icons-outlined">cancel</mat-icon>
                    <span>mark as absent</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1"
                    (click)="deleteAttendance(item)"
                    [disabled]="
                      selectedBusiness.is_owner == 0 && item.session_status == 3
                    "
                  >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete attendance</span>
                  </button>

                  <!-- <button mat-menu-item   (click)="changeAttendanceStatus(1,item)" *ngIf="(item.bookingStatus == 0 || item.bookingStatus == null || item.bookingStatus == 'null') && (selectedBusiness.is_owner == 1 && item.session_status != 3)" >
                  <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                  <span>Mark as present</span>
                  </button>
               
                  <button mat-menu-item  (click)="changeAttendanceStatus(0,item)" *ngIf="(item.bookingStatus == 1 || item.bookingStatus == null || item.bookingStatus == 'null') && (selectedBusiness.is_owner == 1 && item.session_status != 3)" >
                  <mat-icon class="material-icons-outlined">cancel</mat-icon>
                  <span>mark as absent</span>
                  </button>
                  <button mat-menu-item  *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1" (click)="deleteAttendance(item)" [disabled]="selectedBusiness.is_owner == 0 && item.session_status == 3">
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span>Delete attendance</span>
                  </button> -->
                </div>
              </mat-menu>
            </div>

            <p class="booking-meta">
              <span class="label">Assigned to: </span>
              <span class="value">{{ item.employeeName }}</span>
            </p>
             <p class="booking-meta">
              <span class="label">Service mode: </span>
              <span class="value">{{ item.booking_type }}</span>
            </p>
            <p class="booking-meta">
              <span class="label">Status: </span>
              <span class="value">{{ item.bookingStat }}</span>
              <span
                class="label"
                *ngIf="item.paymentStat && item.paymentStat != '---'"
                >, Payment:
              </span>
              <span
                class="value"
                *ngIf="item.paymentStat && item.paymentStat != '---'"
                >{{ item.paymentStat }}</span
              >
            </p>
            <p class="date_booking" *ngIf="item.booking_date">
              {{ item.booking_date ? (item.booking_date | date) : "---" }}
            </p>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- fitness attendance code -->

  <!-- ------------------------------------------------------------------------------------ -->

  <!-- Placeholder design html start -->
  <div
    class="placeholder_started"
     *ngIf="
      bookingsList.length == 0 &&
      interestData.length == 0 &&
      messageList.length == 0 &&
      !loader &&
      selectedValue != '3' && selectedValue != '4' && selectedValueForBeauty != '3'
    "
  >
    <div class="row">
      <!-- <div class="heading_sert">
            <h3>All bookings</h3>
        </div> -->
      <!-- <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/s3.png">
                 </div>
                 <mat-card-title>No business added yet yet</mat-card-title>
                 <mat-card-content>Booking list will appear hear. For that you need to create a business first. It's easy and takes only 2 minutes.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary">
                        <mat-icon>add</mat-icon> 
                        Create new 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div> -->
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 1">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>
              <mat-card-title>No booking to show.</mat-card-title>
              <mat-card-content
                >All the bookings will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
              <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 1">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to create a new booking?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on creating new booking against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 2">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img" *ngIf="selectedValue == 2">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>
              <div class="icm_img" *ngIf="selectedValue == 1">
                <img src="./assets/images/query-s1.jpg" />
              </div>
              <mat-card-title *ngIf="selectedValue == 2"
                >No bookings to show here.</mat-card-title
              >
              <mat-card-title *ngIf="selectedValue == 1"
                >No queries to show here.</mat-card-title
              >

              <mat-card-content *ngIf="selectedValue == 2"
                >All the bookings will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
              <mat-card-content *ngIf="selectedValue == 1"
                >All the queries will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="selectedBusiness.revenue_model == 2 && selectedValue == '1'"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on creating new query against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="selectedBusiness.revenue_model == 2 && selectedValue == '2'"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to create a new booking?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on creating new booking against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 2">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content *ngIf="selectedValue == 2"
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <mat-card-content *ngIf="selectedValue == 1"
                >For any difficulties in adding a new query or issue with
                managing them, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 1">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html end -->

  <!-- Placeholder design html start for attendance -->
  <div
    class="placeholder_started"
    *ngIf="
      attendanceList.length == 0 &&
      selectedBusiness.revenue_model == 2 &&
      selectedValue == '3' &&
      !loader
    "
  >
    <div class="row">
      <!-- <div class="heading_sert">
            <h3>All bookings</h3>
        </div> -->
      <!-- <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/s3.png">
                 </div>
                 <mat-card-title>No business added yet yet</mat-card-title>
                 <mat-card-content>Booking list will appear hear. For that you need to create a business first. It's easy and takes only 2 minutes.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary">
                        <mat-icon>add</mat-icon> 
                        Create new 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div> -->

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>

              <mat-card-title>No attendance list to show here.</mat-card-title>

              <mat-card-content
                >All the attendances will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How attendance work?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on marking present and absent against members. You can check
                this video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openVideoForAttendance()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html end for attendance -->
</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
  <!-- Placeholder design html start -->
  <div class="placeholder_started">
    <div class="row">
      <div class="heading_sert">
        <h3>All bookings</h3>
      </div>
      <div
        class="col-sm-4"
        *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>No business added yet</mat-card-title>
              <mat-card-content
                >Booking list will appear here. For that you need to create a
                business first. It's easy and takes only 2 minutes.
              </mat-card-content>
              <div class="create_btnyh">
                <button
                  mat-flat-button
                  color="primary"
                  (click)="selectcountry()"
                >
                  <mat-icon>add</mat-icon>
                  Create a business
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined" style="height: auto !important">
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>Access denied.</mat-card-title>
              <mat-card-content>
                Business owner with valid premium business subscription or an
                active employee can access this section. Check current plans.
                Recharge pack if expired.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>
              <mat-card-title>No booking to show here</mat-card-title>
              <mat-card-content
                >All the bookings will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html start -->
</section>




<!-- QUERIES START -->
<div
  class="busroy"
  *ngIf="!loader && queryData.length > 0  && (selectedValueForBeauty == '3' || selectedValue == '4')"
>
  <div class="row">
    <div
      class="col-sm-4"
      *ngFor="let item of queryData"
      (click)="viewDetailsforservicequery(item)"
    >
      <mat-card>
        <div class="booking-card">
          <div class="booking-header">
            <div class="left-section" style="position: relative">
              <mat-icon
                [class.new-booking]="item.status == 1"
                [class.under-process]="item.status == 2"
                [class.completed]="item.status == 3"
                class="status-icon"
              ></mat-icon>
              <div
                class="booking-initial"
                
              >
                {{ item.name.slice(0, 1) }}
              </div>
              <!-- <img
                class="booking-initial-img img-fluid rounded-circle"
                [src]="item.image_thumb_url"
                alt=""
                *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              /> -->
              <div class="booking-details">
                <h3 class="booking-name">{{ item.name }}</h3>
                <p class="booking-number">
                  <span
                    class="bookingstar"
                    style="font-size: 14px; color: #888"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
          </div>

          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Status: </span>
            <span class="value">{{ item.item_status }}</span>
          </p>
           <p class="booking-meta">
              <span class="label">Service mode: </span>
              <span class="value">{{ item.s_mode }}</span>
            </p>
         
          <p class="booking-meta">
            <span class="value">{{ item.creation_time | date : 'MMM d, y, h:mm a' : 'UTC' }}</span>
          </p>
        </div>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
 *ngIf="!loader && queryData.length == 0  && (selectedValueForBeauty == '3' || selectedValue == '4')"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/query-s1.jpg" />
            </div>
            <mat-card-title>No service queries to show.</mat-card-title>
            <mat-card-content
              >All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
            </mat-card-content>
            <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
          </div>
        </mat-card>
      </div>
    </div>
<!-- 
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new query?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new query against a business. You can check this video
              as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div> -->
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->

<!-- QUERIES END -->
